// extracted by mini-css-extract-plugin
export default {"logoimg":"sidebar_logoimg__U2E57","sidebarResponsive":"sidebar_sidebarResponsive__FVjvx","enterpriseLogo":"sidebar_enterpriseLogo__Obctc"};